import React from 'react';
import { steps } from '../../data/site';
export function Steps() {
  return <section id="saadan" className="scroll-mt-24 border-y border-line bg-canvas-deep" data-id="element-455" data-mp="y62le178bsjy">
      <div className="mx-auto max-w-content px-5 py-14 md:py-20 lg:px-8" data-id="element-456" data-mp="y8f8stvrav4e">
        <h2 className="font-display text-[clamp(1.75rem,4.5vw,2.75rem)] font-bold leading-[1.05] tracking-tight text-ink" data-id="element-457" data-mp="t782z0d6c60d">
          Sådan foregår det
        </h2>

        <ol className="mt-9 grid gap-8 md:grid-cols-3 md:gap-10" data-id="element-458" data-mp="1lvwxggjq5d35">
          {steps.map((step, index) => <li key={step.title} className="border-t border-line pt-5" data-id="element-459" data-mp="1gxlnm5tfj2kx" data-mpi={index}>
              <span className="font-display text-sm font-bold text-accent-deep" data-id="element-460" data-mp="1c5ajeqrnoumk">{index + 1}</span>
              <h3 className="mt-1.5 font-display text-xl font-bold tracking-tight text-ink" data-id="element-461" data-mp="17791i95yv1co">
                {step.title}
              </h3>
              <p className="mt-2 text-[16px] leading-relaxed text-ink-soft" data-id="element-462" data-mp="24nplrxnuma4j">{step.description}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}